import useGetAllProduct from './useGetAllProduct'

export default function useGetProduct(id) {
    const allProduct = useGetAllProduct()
    const product = allProduct.find(({ node: { productId, sku } }) => id === productId || id === sku)
    return product.node
}
